var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWebsite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.663 15.566c-6.254 1.268-11.018 6.64-11.358 13.184h6.787a24.915 24.915 0 014.57-13.184zm5.681 0a24.916 24.916 0 014.57 13.184H43.7c-.34-6.543-5.103-11.915-11.356-13.183zm2.067 13.184a22.415 22.415 0 00-4.908-12.797 22.416 22.416 0 00-4.907 12.797h9.815zm-9.737 2.5h9.659a22.416 22.416 0 01-4.83 11.797 22.416 22.416 0 01-4.83-11.797zm-2.512 0h-6.77c.747 6.085 5.338 10.981 11.27 12.184a24.916 24.916 0 01-4.5-12.184zm10.182 12.183a24.917 24.917 0 004.5-12.183h6.769c-.747 6.084-5.338 10.98-11.269 12.183zm-2.84 2.784c9.002 0 16.341-7.117 16.702-16.03a1.25 1.25 0 00.009-.294c.003-.13.004-.262.004-.393 0-9.233-7.484-16.717-16.717-16.717-9.232 0-16.717 7.484-16.717 16.717 0 .131.002.262.005.393a1.264 1.264 0 00.009.294c.36 8.914 7.7 16.03 16.703 16.03h.001",
    fill: "#31589F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebsite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Website.c3a251b9.svg";
export { ForwardRef as ReactComponent };